import type { PixelStreaming } from '@epicgames-ps/lib-pixelstreamingfrontend-ue5.5'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { KVAnnotation } from 'types'

import { emitPixelStreamUIInteraction } from './messageUtils'

export const ANNOTATION_BATCH_SIZE = 30
export const ANNOTATION_BATCH_THRESHOLD = 70

export function sendPointAnnotationsBatched(
  pixelStreaming: PixelStreaming,
  allAnnotations: KVAnnotation[]
) {
  const pointAnnotations = KVAnnotation.kestrelPointAnnotations(allAnnotations)

  if (pointAnnotations.length <= ANNOTATION_BATCH_THRESHOLD) {
    emitPixelStreamUIInteraction(pixelStreaming, {
      command: KestrelCommands.LOAD_ANNOTATIONS,
      annotations: pointAnnotations,
    })
    return
  }

  for (let i = 0; i < pointAnnotations.length; i += ANNOTATION_BATCH_SIZE) {
    const batch = pointAnnotations.slice(i, i + ANNOTATION_BATCH_SIZE)
    const isFirstBatch = i === 0
    emitPixelStreamUIInteraction(pixelStreaming, {
      command: isFirstBatch
        ? KestrelCommands.LOAD_ANNOTATIONS
        : KestrelCommands.APPEND_ANNOTATIONS,
      annotations: batch,
    })
  }
}

export function sendPolygonAnnotationsBatched(
  pixelStreaming: PixelStreaming,
  allAnnotations: KVAnnotation[]
) {
  const polygonAnnotations =
    KVAnnotation.kestrelPolygonAnnotations(allAnnotations)

  if (polygonAnnotations.length <= ANNOTATION_BATCH_THRESHOLD) {
    emitPixelStreamUIInteraction(pixelStreaming, {
      command: KestrelCommands.LOAD_SURFACE_AREAS,
      surfaceAreas: polygonAnnotations,
    })
    return
  }

  for (let i = 0; i < polygonAnnotations.length; i += ANNOTATION_BATCH_SIZE) {
    const batch = polygonAnnotations.slice(i, i + ANNOTATION_BATCH_SIZE)
    const isFirstBatch = i === 0
    emitPixelStreamUIInteraction(pixelStreaming, {
      command: isFirstBatch
        ? KestrelCommands.LOAD_SURFACE_AREAS
        : KestrelCommands.APPEND_SURFACE_AREAS,
      surfaceAreas: batch,
    })
  }
}
